import { Card } from '@zorro/design-system/v2/Card';
import { Dropzone } from '@zorro/design-system/v2/Dropzone';
import { Title } from '@zorro/design-system/v2/Title';
import { ClipboardIcon } from '@zorro/shared/assets';
import { Stack } from '@zorro/web/design-system';
import { showErrorNotification } from '@zorro/web/ui-utils';

type Props = {
  /** Swaps the drop target for a plain "nothing here" card. */
  isReadOnly: boolean;
  /** Instruction under the drop target. */
  subtitleText: string;
  /** Status line under the read-only card. */
  readOnlySubtitle: string;
  isMultiple?: boolean;
  onUpload: (files: File[]) => void;
};

export const EmptyFileSection = ({
  isReadOnly,
  subtitleText,
  readOnlySubtitle,
  isMultiple = false,
  onUpload,
}: Props) => {
  return isReadOnly ? (
    <Card variant="white-shadow" mih="12rem" display="flex">
      <Stack align="center" justify="center" gap="xxs" w="100%">
        <ClipboardIcon />
        <Title order={4}>Nothing here yet</Title>
        <Title order={5}>{readOnlySubtitle}</Title>
      </Stack>
    </Card>
  ) : (
    <Dropzone
      w="100%"
      h="100%"
      multiple={isMultiple}
      onDrop={onUpload}
      onReject={(files) => {
        files.forEach((file) => {
          showErrorNotification({
            message: file.errors[0].message,
            title: file.errors[0].code,
          });
        });
      }}
    >
      <Dropzone.Empty subtitle={subtitleText} />
    </Dropzone>
  );
};
